import { render, staticRenderFns } from "./CoeExamCreateForm.vue?vue&type=template&id=58bab79e&scoped=true"
import script from "./CoeExamCreateForm.vue?vue&type=script&lang=js"
export * from "./CoeExamCreateForm.vue?vue&type=script&lang=js"
import style0 from "./CoeExamCreateForm.vue?vue&type=style&index=0&id=58bab79e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bab79e",
  null
  
)

export default component.exports